export default "__VITE_PUBLIC_ASSET__a0cfd4db__"